import { CarModel, Vehicle } from "@tm/models"
import { concat } from "@tm/utils"
import { VehicleSimple } from "./models"

export function mapVehicleToVehicleSimple(vehicle: Vehicle | undefined): VehicleSimple | undefined {
    if (!vehicle) {
        return
    }

    return {
        description: concat(" ", vehicle.manufacturer, vehicle.modelSeries, vehicle.model),
        manufacturerThumbnail: vehicle.manufacturerThumbnail,
        modelSeriesThumbnail: vehicle.modelSeriesThumbnail,
        plateId: vehicle.plateId,
        vin: vehicle.vin,
        registrationNo: vehicle.registrationNo,
        initialRegistration: vehicle.initialRegistration,
        engineCode: vehicle.engineCode,
        mileAge: vehicle.mileAge,
        lastGeneralInspection: vehicle.lastGeneralInspection,
        nextGeneralInspection: vehicle.nextGeneralInspection,
        nextServiceDate: vehicle.nextServiceDate,
        longlife: vehicle.longlife,
        countryCode: vehicle.countryCode,
    }
}

export function mapCarModelToVehicleSimple(model: CarModel | undefined, canUseKbaAsFallbackRegNo: boolean): VehicleSimple | undefined {
    if (!model) {
        return
    }

    let registrationNo: string | undefined = model.registrationNoDetails?.registrationNo || model.registrationNoDetails?.typScheinNr

    // https://jira.dvse.de/browse/NEXT-31010 -> If conflict dialog was opened with a vehicle with country code "CH", we should not use the german kba as a fallback for the registration number
    // The new vehicle is provided by the DAT VIN search, which is mainly used for german vehicles. The user whats to keep the switzerland vehicle
    if (canUseKbaAsFallbackRegNo && !registrationNo) {
        registrationNo = model.registrationNoDetails?.additionalDetails.find((x) => x.type === 23)?.value
    }

    return {
        description: model.fullDescription || model.description,
        manufacturerThumbnail: model.manufacturerThumbnail,
        modelSeriesThumbnail: model.modelSeriesThumbnail,
        plateId: model.registrationNoDetails?.plateId,
        vin: model.registrationNoDetails?.vin,
        /** @todo Remove use of typScheinNr and additionalDetails as soon as the service maps this property to the registrationNo property */
        registrationNo,
        initialRegistration: model.registrationNoDetails?.initialRegistration,
        engineCode:
            model.registrationNoDetails?.engineCodes?.length === 1
                ? model.registrationNoDetails.engineCodes[0]
                : model.engineCodes?.length === 1
                  ? model.engineCodes[0]
                  : undefined,
        longlife: model.registrationNoDetails?.longlife,
    }
}
